module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modeling-popover-wrapper"
  }, [_c('div', [_vm._v(_vm._s(_vm.statusState))]), _vm._v(" "), _c('el-popover', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.statusState !== '无'),
      expression: "statusState !== '无'"
    }],
    attrs: {
      "placement": "top",
      "visible-arrow": false,
      "width": 200,
      "trigger": "hover"
    }
  }, [_c('div', {
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_c('img', {
    staticClass: "icon-img",
    attrs: {
      "src": require("../../../../assets/images/icon/icon_info.png")
    }
  })]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "modeling-title"
  }, [_vm._v("建模详情")]), _vm._v(" "), _c('div', {
    staticClass: "modeling-content"
  }, [_c('span', [_vm._v("一体机 主屏幕")]), _vm._v(" "), _c('span', {
    style: (_vm.statusColor('dianaModelStatus'))
  }, [_vm._v("\n                    " + _vm._s(_vm.modelingStatus('dianaModelStatus')) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "modeling-content"
  }, [_c('span', [_vm._v("一体机 运动相机")]), _vm._v(" "), _c('span', {
    style: (_vm.statusColor('endPointModelStatus'))
  }, [_vm._v("\n                    " + _vm._s(_vm.modelingStatus('endPointModelStatus')) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "modeling-content"
  }, [_c('span', [_vm._v("坐位体前屈")]), _vm._v(" "), _c('span', {
    style: (_vm.statusColor('sitAndReachModelStatus'))
  }, [_vm._v("\n                    " + _vm._s(_vm.modelingStatus('sitAndReachModelStatus')) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "modeling-content"
  }, [_c('span', [_vm._v("体检一体机")]), _vm._v(" "), _c('span', {
    style: (_vm.statusColor('examDianaModelStatus'))
  }, [_vm._v("\n                    " + _vm._s(_vm.modelingStatus('examDianaModelStatus')) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "modeling-content"
  }, [_c('span', [_vm._v("超脑")]), _vm._v(" "), _c('span', {
    style: (_vm.statusColor('hyperbrainModelStatus'))
  }, [_vm._v("\n                    " + _vm._s(_vm.modelingStatus('hyperbrainModelStatus')) + "\n                ")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-03400db6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/UserManage/UserManage/Components/ModelPopover.vue
// module id = 929
// module chunks = 0